import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tabs, Tab, Button } from "@mui/material";
import ProfileTop from "../../features/ProfileDetail/profileTop";
import PersonalInformation from "../../features/ProfileDetail/personalInformation";

import Documents from "../../features/ProfileDetail/documents";
import { USER_TYPE_SLUGS, USER_TYPES } from "../../utils/enums";
import { Applicants } from "../../features/ProfileDetail/applicants";
import { useUserDetailsMutation } from "../../service/users";
import {
  AgentList,
  CommonBody,
  CompanyList,
  UsersList,
} from "../../types/General";
import Loader from "../../constants/Loader";
import { errorToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import AgentCommission from "../../features/ProfileDetail/agentCommission";
import PaymentHistorySalariedAgent from "../../features/ProfileDetail/PaymentHistory";
import IndividualPaymentHistory from "../../features/ProfileDetail/individualPaymentHistory";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ProfileDetail = () => {
  const { id } = useParams();
  const { type } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const agentType = queryParams.get("agentType");

  const finalType = type === "agent" ? agentType : type;

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [getDetail] = useUserDetailsMutation();
  const [userDetails, setUserDetails] = useState<
    UsersList | CompanyList | AgentList | null
  >(null);

  const [valueTabs, setValueTabs] = React.useState(0);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const tabs = [
    {
      id: 0,
      title: "Personal Information",
      component: <PersonalInformation type={finalType} details={userDetails} />,
    },
    {
      id: 1,
      title: "Documents",
      component: <Documents details={userDetails} type={finalType} />,
    },
    {
      id: 2,
      title: "Applications",
      component: <Applicants id={id} type={finalType} />,
    },
    {
      id: 3,
      title: "Payment History",
      component:
        finalType === USER_TYPE_SLUGS.SALARIED_AGENT ? (
          <PaymentHistorySalariedAgent id={id} type={finalType} />
        ) : (
          <IndividualPaymentHistory id={id} type={finalType} />
        ),
    },
  ];

  if (finalType === USER_TYPE_SLUGS.SALARIED_AGENT) {
    // tabs.push({ id: 4, title: "Attendance", component: <Attendance /> });

    tabs.push({
      id: 4,
      title: "Manage Extra Benefits",
      component: <AgentCommission id={id} details={userDetails} />,
    });
  }

  const getUserDetails = async (id: number) => {
    setLoading(true);
    const body = {
      user_type:
        finalType === USER_TYPE_SLUGS.INDIVIDUAL
          ? USER_TYPES.INDIVIDUAL
          : finalType === USER_TYPE_SLUGS.COMPANY
            ? USER_TYPES.COMPANY
            : USER_TYPES.AGENT,
    };
    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await getDetail({ body: encryptedBody, id }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setUserDetails(response?.data);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getUserDetails(Number(id));
    }
  }, [valueTabs]);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title fdx">
        <div>
          <h1>Profile Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Users - Profile Detail
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_blue" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <ProfileTop type={finalType} details={userDetails} />

      <Box className="custom_tabs2" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          className="custom_tabs_links"
        >
          {tabs.map((tab) => (
            <Tab key={tab.id} label={tab.title} {...a11yProps(tab.id)} />
          ))}
        </Tabs>
      </Box>

      <div className="cards">
        {tabs.map((tab) => (
          <CustomTabPanel key={tab.id} value={valueTabs} index={tab.id}>
            {tab.component}
          </CustomTabPanel>
        ))}
      </div>
    </MainContainer>
  );
};

export default ProfileDetail;
